import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaDesdeFormGroup = ({ fIsSubmitting, iError, iTouched }) => {
  return (
    <Form.Group>
      <Form.Label md={4} text='Desde' alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaDesde'>
          {({ field }) => <Form.InputDate {...field} id='date-fechaDesde' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDesdeFormGroup)
